'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.flattenN.implementInherited(_immutable.Iterable, function (depth, subject) {
  return subject.flatten(depth);
});

exports.default = _TransmuteCollection.flattenN;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_flattenN.js
// module id = 179
// module chunks = 0 1